// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table4_container__E4GjK {
  overflow-x: hidden;
  overflow-y: hidden;
}

.table4_container__E4GjK table {
  max-width: auto;
  max-height: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border-spacing: 0;
  text-align: left;
}

.table4_body__3w3dm {
  overflow: auto;
}
.table4_header__97Kjq {
  text-align: center;
  color: #055437;
  font-weight: 600;
  font-size: 1em;
  /* display: table-header-group; */
  border: 1px solid #22835f;
  background: none !important;
  /* background-color: #055437 !important; */
}

.table4_header__97Kjq tr th {
  padding: 0.5em 2em;
}

.table4_head__nv1MM {
  padding: 0.4em 0;
  justify-content: space-evenly;
}

.table4_data__dQAAl {
  padding: 0.2em 2em;
  width: 100vw;
  font-weight: 500;
}

.table4_data__dQAAl * {
  margin: 0;
}

.table4_actionButton__fOBHb {
  background: none;
  border: none;
}

.table4_rowHeader__Yfacv td {
  font-weight: 800;
}
.table4_rowHeader__Yfacv td * {
  margin: 0;
}

.table4_row__eDcEz {
  border: 1px solid #22835f;
}
`, "",{"version":3,"sources":["webpack://./src/components/Table/table4.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EAGjB,gBAAgB;AAFlB;;AAKA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,yBAAyB;EACzB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".container {\n  overflow-x: hidden;\n  overflow-y: hidden;\n}\n\n.container table {\n  max-width: auto;\n  max-height: 100%;\n  table-layout: fixed;\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n.container table {\n  text-align: left;\n}\n\n.body {\n  overflow: auto;\n}\n.header {\n  text-align: center;\n  color: #055437;\n  font-weight: 600;\n  font-size: 1em;\n  /* display: table-header-group; */\n  border: 1px solid #22835f;\n  background: none !important;\n  /* background-color: #055437 !important; */\n}\n\n.header tr th {\n  padding: 0.5em 2em;\n}\n\n.head {\n  padding: 0.4em 0;\n  justify-content: space-evenly;\n}\n\n.data {\n  padding: 0.2em 2em;\n  width: 100vw;\n  font-weight: 500;\n}\n\n.data * {\n  margin: 0;\n}\n\n.actionButton {\n  background: none;\n  border: none;\n}\n\n.rowHeader td {\n  font-weight: 800;\n}\n.rowHeader td * {\n  margin: 0;\n}\n\n.row {\n  border: 1px solid #22835f;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `table4_container__E4GjK`,
	"body": `table4_body__3w3dm`,
	"header": `table4_header__97Kjq`,
	"head": `table4_head__nv1MM`,
	"data": `table4_data__dQAAl`,
	"actionButton": `table4_actionButton__fOBHb`,
	"rowHeader": `table4_rowHeader__Yfacv`,
	"row": `table4_row__eDcEz`
};
export default ___CSS_LOADER_EXPORT___;
